module.exports = __webpack_public_path__ + "img/dac.2d219845.png";